import { render, staticRenderFns } from "./PageRequestNewPassword.vue?vue&type=template&id=e52ec9e8&scoped=true"
import script from "./PageRequestNewPassword.vue?vue&type=script&lang=js"
export * from "./PageRequestNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52ec9e8",
  null
  
)

export default component.exports